import {Stack, useLocalSearchParams } from "expo-router";
import { useEffect, useState } from "react";
import { getStreamClient } from "@/services/stream/client";
import { UniverseStreamChannel } from "@/services/stream/types";
import { StyleSheet, View } from 'react-native';

import { ChannelView } from "@/components/chat/ChannelView";


export default function ChannelId() {
    const { channelId } = useLocalSearchParams<{ channelId: string }>();
    const [channel, setChannel] = useState<UniverseStreamChannel | null>(null);

    useEffect(() => {
        let cancelled = false;

        // Set the current channel ID globally so notifications can check it
        (global as any).__CURRENT_CHANNEL_ID__ = channelId;

        (async () => {
            try {
                const client = getStreamClient();

                const ch = client.channel('messaging', channelId) as UniverseStreamChannel;
                await ch.watch();

                if (!cancelled) {
                    setChannel(ch);
                }
            } catch (e) {
                console.log("Channel watch/connect error:", e);
            }
        })();

        return () => {
            cancelled = true;
            // Clear the current channel ID when leaving
            (global as any).__CURRENT_CHANNEL_ID__ = null;
        };
    }, [channelId]);

    return (
        <View style={styles.container}>
            <Stack.Screen
                options={{
                    headerShown: false,
                }}
            />

            {channel ? (
                <ChannelView channel={channel} />
            ) : null}
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
});